<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalPaymentVisible" :vm-is-valid="!$v.payment.$invalid" :vm-title='getTitle')
        vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                    vm-date-picker(style="width: 100%" :label='$t("payments.date_pay")' :danger="$v.payment.date_pay.$invalid && $v.payment.date_pay.$model" :danger-text="$t('validation.required', { attribute: $t('payments.date_pay') })" v-model="payment.date_pay")
            vm-col(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                    vm-currency(:placeholder='$t("payments.amount_placeholder")' :danger="$v.payment.amount.$invalid && $v.payment.amount.$model" v-model="payment.amount" :label='$t("payments.amount")')
            vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
                b-form-group
                    input(type="file" ref="file" accept="image/jpg, image/jpeg, image/png, application/pdf" @change="handleFileUpload()")
</template>
<script>
import moment from 'moment'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalPayment',
  props: {
    payment: {
      type: Object
    },
    invoice: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    file: ''
  }),
  validations () {
    return {
      payment: {
        date_pay: {
          required
        },
        amount: {
          required,
          file: {
            required: requiredIf(function () { return this.fileValidate })
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalPaymentVisible',
      'inOrder'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('payments.add') : this.$t('payments.edit')
    },
    amountDue () {
      return this.invoice.amount_due ? this.invoice.amount_due : 0
    },
    fileValidate () {
      return this.file.length < 1 && this.isAdd
    }
  },
  methods: {
    ...mapActions([
      'setModalPaymentVisible',
      'addPayment',
      'editPayment'
    ]),
    async handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      this.payment.date_pay = moment(this.payment.date_pay).format('YYYY-MM-DD')
      this.isAdd ? await this.addPayment({ payment: this.payment, project: this.inOrder, file: this.file }) : await this.editPayment({ payment: this.payment, project: this.inOrder, file: this.file })
      this.file = ''
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalPaymentVisible(false)
    }
  }
}
</script>
